import * as React from 'react';

import './style.css';
import { Link } from 'react-router-dom';
import DescWrap from './DescWrap';

export default function ImageLink({width='100%',image=null, name=null, description=null, link=null, button=null, title=null, reverse=false}){

    return(
        <div className="flex-column image-link" style={{gap: "0.5rem", alignItems:"center", justifyContent:"start", width:width, flexDirection:reverse?"column-reverse":"none"}}>
            <div className="image-square">
                <img src={image}></img>
            </div>
            
            <DescWrap name={name} title={title} description={description} button={button} link={link}></DescWrap>
            
        </div>
    )
}